/**
 * @copyright
 * Copyright (c) 2024 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import ApiCaller from "~/api/ApiCaller";
import { PostSetPasswordRequestBody, PostSetPasswordResponse } from "~/features/setPassword/types";

const SetPasswordApi = {
  postSetPassword: (data: PostSetPasswordRequestBody) => {
    const url = "/v1/password/resetpassword";

    return ApiCaller.post<PostSetPasswordResponse>(url, data);
  },
};

export default SetPasswordApi;
